import { ApplicationDirtyStateModel, RootState, MStoreConstants, StoreConstants } from '@/types';
import { GetterTree } from 'vuex';
import { LocalStorage } from '@/utils';

export const getters: GetterTree<ApplicationDirtyStateModel, RootState> = {
  [StoreConstants.ApplicationDirty.Getters.IsApplicationDirty](state) {
    return state.isDirty;
  },
  [StoreConstants.ApplicationDirty.Getters.IsApplicationDirtyOnAnotherTab](state) {
    const isDirtyOnAnotherTab = LocalStorage.get(MStoreConstants.LocalStorageKeys.IsApplicationDirty);
    return state.isDirtyOnAnotherTab || (!state.isDirty && isDirtyOnAnotherTab);
  },
  isApplicationDirtyOnModal(state) {
    return state.isDirtyOnModal;
  },
  [StoreConstants.ApplicationDirty.Getters.ShowApplicationDirtyModal](state) {
    return state.showModal;
  },
  [StoreConstants.ApplicationDirty.Getters.ApplicationDirtyRouteNavigatedTo](state) {
    return state.routeNavigatedTo;
  }
};
